export interface OtpErrors {
  isLimitExhaustedError?: boolean;
  isLimitExceededError?: boolean;
  isPhoneNotFoundError?: boolean;
}

export type OtpHandleError = (errors?: OtpErrors) => void;

export type OtpHandleResendError = (errors?: OtpErrors) => void;

export enum OtpType {
  PASSWORD_RECOVERY = 'password_recovery',
  EXTENDED_PRODUCTS_CONTRACTS = 'extended_products_contracts',
  CANDIDATE_CONTRACT = 'candidate_contract',
  SIGN_UNILATERALLY = 'sign_unilaterally',
  CANDIDATE_REGISTRATION = 'candidate_registration',
  REGISTRATION = 'registration',
  ACT_OTP = 'act_otp',
  STANDARDS = 'standards',
  CONTRACT_TERMINATION = 'contract_termination',
  AGENT_CONTRACT = 'agent_contract',
}

export type Cooldowns = Partial<Record<OtpType | string, number>>;
